export const AnalyticsEvents = {
  // Navigation
  PAGE_VIEWED: 'page_viewed',

  // Auth
  USER_LOGGED_IN: 'user_logged_in',
  USER_LOGGED_OUT: 'user_logged_out',

  // Competency Maps
  COMPETENCY_MAP_VIEWED: 'competency_map_viewed',
  COMPETENCY_MAP_VIEW_CHANGED: 'competency_map_view_changed',
  COMPETENCY_MAP_CREATED: 'competency_map_created',
  COMPETENCY_MAP_EDITED: 'competency_map_edited',
  COMPETENCY_ASSIGNED: 'competency_assigned',
  COMPETENCY_LEVEL_CHANGED: 'competency_level_changed',
  COMPETENCY_REVOKED: 'competency_revoked',
  COMPETENCY_REVIEW_REQUESTED: 'competency_review_requested',
  COMPETENCY_REVIEW_DECIDED: 'competency_review_decided',

  // Performance Reviews
  REVIEW_ROUND_CREATED: 'review_round_created',
  REVIEW_ROUND_VIEWED: 'review_round_viewed',
  REVIEW_SUBMITTED: 'review_submitted',
  REVIEW_RESULTS_VIEWED: 'review_results_viewed',
  REVIEW_SUMMARY_PUBLISHED: 'review_summary_published',

  // Goals
  GOAL_CREATED: 'goal_created',
  GOAL_STATUS_CHANGED: 'goal_status_changed',
  GOAL_COMPLETED: 'goal_completed',

  // Teams & Users
  TEAM_VIEWED: 'team_viewed',
  USER_PROFILE_VIEWED: 'user_profile_viewed',
  USER_INVITED: 'user_invited',

  // Settings
  SETTINGS_CHANGED: 'settings_changed',
  ORGANIZATION_SETTINGS_CHANGED: 'organization_settings_changed',

  // Onboarding
  ONBOARDING_STARTED: 'onboarding_started',
  ONBOARDING_STEP_COMPLETED: 'onboarding_step_completed',
  ONBOARDING_COMPLETED: 'onboarding_completed',
  ONBOARDING_SKIPPED: 'onboarding_skipped',

  // Tech Radar
  TECH_RADAR_VIEWED: 'tech_radar_viewed',
  TECH_RADAR_ITEM_CLICKED: 'tech_radar_item_clicked',

  // Review 360
  REVIEW_360_CYCLE_CREATED: 'review_360_cycle_created',
  REVIEW_360_CYCLE_STATUS_CHANGED: 'review_360_cycle_status_changed',
  REVIEW_360_NOMINATION_APPROVED: 'review_360_nomination_approved',
  REVIEW_360_TEMPLATE_CREATED: 'review_360_template_created',
  REVIEW_360_RESPONSE_SUBMITTED: 'review_360_response_submitted',

  // Essays & quarterly reports
  ESSAY_CREATED: 'essay_created',
  ESSAY_SUBMITTED: 'essay_submitted',
  ESSAY_UNSUBMITTED: 'essay_unsubmitted',
  ESSAY_EXPORTED: 'essay_exported',
  ESSAY_AI_PROMPT_COPIED: 'essay_ai_prompt_copied',
  ESSAYS_COMPILED: 'essays_compiled',
  DOCUMENT_RETURNED_FOR_REWORK: 'document_returned_for_rework',
  QUARTERLY_REPORT_GENERATED: 'quarterly_report_generated',
  QUARTERLY_REPORT_SUBMITTED: 'quarterly_report_submitted',
  QUARTERLY_SCORE_SAVED: 'quarterly_score_saved',

  // Learning
  COURSE_ENROLLED: 'course_enrolled',
  COURSE_QUIZ_SUBMITTED: 'course_quiz_submitted',

  // Help & beta features
  HELP_OPENED: 'help_opened',
  HELP_SECTION_VIEWED: 'help_section_viewed',
  HELP_QUESTION_OPENED: 'help_question_opened',
  FEATURE_FLAG_TOGGLED: 'feature_flag_toggled',
} as const;

export type AnalyticsEvent = (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];
